import { AUTH_USER, UNAUTH_USER, AUTH_ERROR, AUTH_WS, AUTH_FORGOT, AUTH_FORGOT_LOADING, AUTH_RESET_SHOW, AUTH_RESET_LOADING } from '../actions/index';

let initialState = {
  "authenticated": false,
  "error": '',
  "ws_authenticated": false,
  "forgotPassword": true,
  "showPasswordReset": true,
  "loading": false,
}

export default function(state = initialState, action) {
  switch(action.type) {
    case AUTH_USER:
      return { ...state, error: '', authenticated: true };
    case UNAUTH_USER:
      return { ...state, authenticated: false };
    case AUTH_ERROR:
      return { ...state, error: action.payload };
    case AUTH_WS:
      return { ...state, ws_authenticated: true, socket: action.socket };
    case AUTH_FORGOT:
      return { ...state, forgotPassword: action.payload };
    case AUTH_FORGOT_LOADING:
      return { ...state, loading: action.payload };
    case AUTH_RESET_SHOW:
      return { ...state, showPasswordReset: action.payload };
    case AUTH_RESET_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_auth.js